import {Injectable} from '@angular/core';
import {Observable, Observer} from 'rxjs';
import {share} from 'rxjs/operators';
import {Error} from '../shared/error'

@Injectable()
export class ErrorNotifierService {
  private errorObservable: Observable<any>;
  private errorObserver!: Observer<Error>;

  private timedErrorObservable: Observable<any>;
  private timedErrorObserver!: Observer<Error>;

  private clearErrorObservable: Observable<any>;
  private clearErrorObserver!: Observer<boolean>;

  constructor() {
    this.errorObservable = new Observable((observer: Observer<Error>) => {
      this.errorObserver = observer;
    }).pipe(share());
    this.timedErrorObservable = new Observable((observer: Observer<Error>) => {
      this.timedErrorObserver = observer;
    }).pipe(share());
    this.clearErrorObservable = new Observable((observer: Observer<boolean>) => {
      this.clearErrorObserver = observer;
    }).pipe(share());
  }

  notifyError(error: Error): void {
    if (this.errorObserver) {
      this.errorObserver.next(error);
    }
  }

  onError(callback: (e: Error) => any): void {
    this.errorObservable.subscribe(callback);
  }

  notifyTimedError(error: Error): void {
    if (this.timedErrorObserver) {
      this.timedErrorObserver.next(error);
    }
  }

  onTimedError(callback: (e: Error) => any): void {
    this.timedErrorObservable.subscribe(callback);
  }

  clearError(): void {
    if (this.clearErrorObserver) {
      this.clearErrorObserver.next(true);
    }
  }

  onClearError(callback: () => any): void {
    this.clearErrorObservable.subscribe(callback);
  }
}
